const defaultDateOptions: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric'
}

export function localDate(date: string, options?: Intl.DateTimeFormatOptions) {
  const dateObj = new Date(date)
  return dateObj.toLocaleDateString('default', options || defaultDateOptions)
}
